<as-split
    direction="horizontal"
    [gutterSize]="2"
    [unit]="'pixel'"
    (dragEnd)="config.set('menuSize', menuSplit.clientWidth)"
    [disabled]="config.value.menuCollapsed"
>
    <as-split-area
        #menuSplit
        [size]="config.value.menuCollapsed ? 56 : config.value.menuSize ?? 215"
        [minSize]="config.value.menuCollapsed ? 56 : 215"
        [maxSize]="config.value.menuCollapsed ? 56 : 400"
    >
        @if (pages.rootPage.children) {
            <app-menu></app-menu>
        }
    </as-split-area>
    <as-split-area>
        <mat-tab-group
            style="flex: 1"
            [style.display]="pages.tabs.length > 0 ? '' : 'none'"
            [(selectedIndex)]="pages.selectedTabIndex"
            (selectedIndexChange)="pages.loadCurrentPageContent()"
        >
            @for (page of pages.tabs; track page) {
                <mat-tab>
                    <ng-template mat-tab-label>
                        <div class="tab"
                            [ngx-contextmenu]="tabCtxMenu"
                            [ngx-menu-context]="page"
                            (pointerdown)="$event.which == 2 && pages.closeTab(page)"
                            [style.font-style]="page.isPreviewTab ? 'italic' : ''"
                        >
                            <mat-icon [fontIcon]="page.icon || 'edit_document'"></mat-icon>
                            <span style="flex: 1">
                                <span>{{page.label?.slice(0, 20)}}</span>
                            </span>

                            <mat-icon class="close-button" (click)="pages.closeTab(page)">close</mat-icon>
                        </div>
                    </ng-template>
                </mat-tab>
            }
        </mat-tab-group>

        @for (page of pages.tabs; track page; let i = $index) {
            @if (pages.selectedTabIndex == i) {
                <div class="container">
                    @switch (page.kind) {
                        @case ('code') {
                            @if (utils.getPistonRuntimes.length > 0 && checkLangIsExecutable(page)) {
                                <button mat-icon-button class="run-button">
                                    <mat-icon (click)="utils.executeCode(page)">play_arrow</mat-icon>
                                </button>
                            }

                            <app-vscode
                                [code]="page.content"
                                (codeChange)="pages.onPageContentChange(page, $event)"
                                [language]="page.options?.['language'] || 'auto'"
                                [minimap]="page.options?.['minimap']"
                                [folding]="page.options?.['folding']"
                                [fontSize]="page.options?.['fontSize']"
                                [colorDecorators]="page.options?.['colorDecorators']"
                                [tabSize]="page.options?.['tabSize']"
                                [tabSize]="4"
                                [installationLocation]="'./lib/monaco/vs'"
                            />
                        }

                        @case ('canvas') {
                            <div
                                style="height: 100%"
                            >
                                <app-diagram
                                    [page]="page"
                                />
                            </div>
                        }

                        @case ('fetch') {
                            <div

                                style="height: 100%"
                            >
                                <app-fetch-page
                                    [page]="page"
                                />
                            </div>
                        }

                        @default {
                            <ngx-stackedit
                                mode="edit"
                                [showPreview]="false"
                                [showCodeRunButton]="true"
                                codeRunner="piston"
                                [(value)]="page.content"
                                (valueChange)="$event.trim() && pages.onPageContentChange(page, $event)"
                                (onImageUpload)="onImageUpload($event)"
                            />
                        }
                    }
                </div>
            }
        }
        @empty {
            <div class="empty-panel">
                <div class="logo">
                    <img src="/assets/app-icon.png" style="width: 300px;"/>
                </div>
                <div>
                    <div>Show All Commands</div>
                    <div>Go to File</div>
                    <div>Toggle Terminal</div>
                    <div>Find in Files</div>
                </div>
            </div>
        }
    </as-split-area>
</as-split>
